<ul class="layout-menu">
  <li class="layout-root-menuitem">
    <ul>
      <li>
        <a pRipple routerLink="/alerts" routerLinkActive="active-route">
          <i class="pi pi-ticket layout-menuitem-icon"></i>
          <span class="layout-menuitem-text">Your Stores</span>
        </a>
      </li>
      <!-- Maintenance is hidden until the feature ships (routes are also
           commented out in app-routing.module.ts).
      @if (!previewMode) {
        <li>
          <a
            pRipple
            (click)="isMaintenanceExpanded = !isMaintenanceExpanded"
            (keyup.enter)="isMaintenanceExpanded = !isMaintenanceExpanded"
          >
            <i class="pi pi-cog layout-menuitem-icon"></i>
            <span class="layout-menuitem-text">Maintenance</span>
            <i class="pi pi-fw pi-angle-down layout-submenu-toggler"></i>
          </a>
          <ul [class.hidden]="!isMaintenanceExpanded" class="overflow-hidden">
            <li>
              <a
                pRipple
                routerLink="/maintenance/users"
                routerLinkActive="active-route"
              >
                <i class="pi pi-user-edit layout-menuitem-icon"></i>
                <span class="layout-menuitem-text">User Management</span>
              </a>
            </li>
          </ul>
        </li>
      }
      -->
    </ul>
  </li>
</ul>
